import { Controller } from "@hotwired/stimulus"
import { Dropzone } from "dropzone"
import { getMetaValue } from "../packs/global/utils.js";

// Connects to data-controller="dropzone"
export default class extends Controller {
  static targets = ["input"]
  static values = {
    paramName: { type: String, default: "file" },
    acceptedFiles: { type: String, default: "*" },
    maxFiles: { type: Number, default: 100 },
    directUpload: { type: Boolean, default: true },
    dictDefaultMessage: { type: String, default: "" },
  }

  connect() {
    try {
      this.dropzone = new Dropzone(this.element, this.options)
    } catch (error) {
      // console.error(error);
    }
  }

  beforeTurboCache() {
    this.dropzone?.destroy()
  }

  clear() {
    if (this.dropzone) {
      this.dropzone.removeAllFiles(true)
    }
  }

  // Schreibt die aktuell in Dropzone vorhandenen Dateien in das versteckte
  // Formular-Input, damit sie mit dem Formular mitgeschickt werden.
  writeFileToInput(dz) {
    if (!this.hasInputTarget) return
    const dt = new DataTransfer()
    dz.files.forEach((f) => dt.items.add(f))
    this.inputTarget.files = dt.files
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  get options() {
    const directUpload = this.directUploadValue
    const controller = this

    const conf = {
      paramName: this.paramNameValue,
      acceptedFiles: this.acceptedFilesValue === "*" ? null : this.acceptedFilesValue,
      maxFiles: this.maxFilesValue,
      autoProcessQueue: directUpload,
      autoQueue: directUpload,
      addRemoveLinks: !directUpload,
      dictRemoveFile: "Entfernen",
      init: function () {
        if (directUpload) {
          this.on("success", function (file, turboStreamResponse) {
            Turbo.renderStreamMessage(turboStreamResponse) // Wir erwarten, dass der Server mit Turbo Stream antwortet

            // Erfolgsicon entfernen, damits nicht bei einem späteren Turbo Event wieder angezeigt wird
            setTimeout(() => {
              file.previewElement.querySelector(".dz-success-mark")?.remove()
            }, 2000)
          })
        } else {
          this.on("addedfile", function (file) {
            if (!controller.hasInputTarget) return

            // Bei Einzeldatei-Fragen ersetzt eine neue Auswahl die vorherige.
            if (controller.maxFilesValue === 1) {
              const existing = this.files.filter((f) => f !== file)
              existing.forEach((f) => this.removeFile(f))
            }

            controller.writeFileToInput(this)

            file.status = Dropzone.SUCCESS
            this.emit("success", file)
            this.emit("complete", file)
          })
          this.on("removedfile", function () {
            controller.writeFileToInput(this)
          })
        }
      },
    }

    // Standardmässig gehen wir davon aus, dass Dropzone auf einem Formular-Element ist.
    // Es kann aber optional auch eine URL via data-Attribut angegeben werden, sodass Dropzone auf einem beliebigen Element verwendet werden kann.
    if (directUpload && this.element.dataset.uploadUrl) {
      conf.url = this.element.dataset.uploadUrl
      conf.headers = {
        "X-CSRF-Token": getMetaValue("csrf-token")
      }
      conf.method = this.element.dataset.method || "post"
    }

    if (!directUpload) {
      conf.url = "about:blank"
    }

    if (this.dictDefaultMessageValue) {
      conf.dictDefaultMessage = this.dictDefaultMessageValue
    }

    return conf
  }
}
